module.exports = __webpack_public_path__ + "static/media/s1.3270a1f4.svg";